import styled from 'styled-components'

const TABLET_LANDSCAPE = 'tablet-landscape'

export const sharedContainerStyles = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ gap }) => gap || '16px'};
  border-radius: 0px;
`

export const StyledContainer = styled(sharedContainerStyles)`
  padding: 40px 16px;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  flex: 1 0 0;
  background: #fff;

  ${props => props.theme.mediaQuery.up(TABLET_LANDSCAPE)} {
    padding: 72px 32px;
    justify-content: center;
    align-items: center;
    flex: 0 1 auto;
    border-radius: 0px;
    border: none;
  }
`

export const StyledEmptyCartContainer = styled(sharedContainerStyles)`
  flex-direction: column;
  justify-content: center;
  align-self: stretch;

  ${props => props.theme.mediaQuery.up(TABLET_LANDSCAPE)} {
    align-self: auto;
  }
`

export const StyledReturnHomeContainer = styled(sharedContainerStyles)`
  justify-content: center;
  align-self: stretch;

  ${props => props.theme.mediaQuery.up(TABLET_LANDSCAPE)} {
    align-self: auto;
  }
`

export const StyledSeparator = styled(sharedContainerStyles)`
  align-self: center;
  height: 1px;
  width: 100%;
  background: #d4d4d6;

  ${props => props.theme.mediaQuery.up(TABLET_LANDSCAPE)} {
    width: 1004px;
    background: #dedede;
  }
`

export const SupportBarWrapper = styled(sharedContainerStyles)`
  justify-content: center;
`

export const StyledTextContainer = styled(sharedContainerStyles)``

export const sharedTextStyles = styled.span`
  color: ${({ color }) => color || '#333'};
  font-family: "Roboto";
  font-size: ${({ fontSize }) => fontSize || '14px'};
  font-weight: ${({ fontWeight }) => fontWeight || '500'};
  line-height: ${({ height }) => height || 'normal'};
  text-decoration-line: ${({ textDecoration }) => textDecoration || 'none'};
  text-align: center;
`

export const StyledEmptyCartText = styled(sharedTextStyles)`
  ${props => props.theme.mediaQuery.up(TABLET_LANDSCAPE)} {
    font-size: 32px;
    line-height: normal;
  }
`

export const StyledReturnHomeText = styled(sharedTextStyles)`
  ${props => props.theme.mediaQuery.up(TABLET_LANDSCAPE)} {
    font-size: 16px;
    line-height: 24px;
  }
`
